import { render, staticRenderFns } from "./TransDb2Online.vue?vue&type=template&id=0b90c62c&scoped=true&"
import script from "./TransDb2Online.vue?vue&type=script&lang=js&"
export * from "./TransDb2Online.vue?vue&type=script&lang=js&"
import style0 from "./TransDb2Online.vue?vue&type=style&index=0&id=0b90c62c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b90c62c",
  null
  
)

export default component.exports